import React from 'react';
import { Label, ProgressBar, Skeleton, tokens } from '@welbe/web-design-system';

import { Button } from '@welbe/design-system';

import { ReactComponent as Icon } from './assets/Icon.svg';

import getProgressColor from 'Views/Campaigns/components/Campaign/Tabs/Evaluations/helpers/getProgressColor';

import {
	Container,
	ContainerHeader,
	ContainerTextHeader,
	ContainerContent,
	WrapperSkeleton,
	Wrapper,
	CardContainer,
	ContainerUpperHeader,
} from './Card.styles';
import { drawerInfoProps } from 'Views/Campaigns/components/Campaign/Tabs/Evaluations/Evaluations';

interface CardProps {
	url: string;
	title?: string;
	subtitle?: string;
	description?: string;
	formUrl?: string;
	porcent?: number;
	onChangeDrawerInfo?: (e: drawerInfoProps) => void;
	loading?: boolean;
	variant?: 'total' | 'detail';
	requiredPercentage: string | number;
}

export const Card = ({
	url,
	title,
	subtitle,
	description,
	porcent,
	loading,
	onChangeDrawerInfo,
	variant,
	requiredPercentage,
}: CardProps): JSX.Element => {
	if (loading) {
		return (
			<Container>
				<CardContainer>
					<WrapperSkeleton>
						{[...Array(4).keys()].map((item) => (
							<Skeleton height="64px" key={item} />
						))}
					</WrapperSkeleton>
				</CardContainer>
			</Container>
		);
	}

	return (
		<Container>
			<CardContainer>
				{variant !== 'total' && (
					<ContainerUpperHeader>
						<Label>{`Se requiere al menos el ${
							requiredPercentage || 0
						}%`}</Label>
						<ProgressBar
							progressColor={getProgressColor(porcent || 0)}
							percentValue={porcent || 0}
							donutSize="75px"
							isDonut
							hasLabel
							backgroundColor={tokens.color_gray_medium}
						/>
					</ContainerUpperHeader>
				)}
				<Wrapper>
					<ContainerHeader>
						<Icon />
						<ContainerTextHeader>
							<h3>{subtitle}</h3>
							<h2>{title}</h2>
						</ContainerTextHeader>
					</ContainerHeader>
					<ContainerContent>
						{description}
						<Button
							variant="plain"
							width="fit-content"
							color="#5082C2"
							onClick={() =>
								onChangeDrawerInfo && onChangeDrawerInfo({ isOpen: true, url })
							}
						>
							Ver cuestionario
						</Button>
					</ContainerContent>
				</Wrapper>
			</CardContainer>
		</Container>
	);
};
